import React from "react";
import { connect } from "react-redux";
import * as drivers from "../../modules/drivers";
import * as styles from "../../styles/components/DriverSelect.css";
import { DRIVER_ORDER } from "./Drivers/info";

function DriverItem({ name, isSelected, onSelect }) {
    return (
        <button
            className={`${styles.driverItem} ${isSelected &&
                styles.isSelected}`}
            onClick={() => onSelect(name)}
        >
            {name}
        </button>
    );
}

function DriverSelect({ items, selectDriver }) {
    return (
        <div className={styles.driverSelect}>
            {items.map(({ name, isSelected }) => (
                <DriverItem
                    key={name}
                    name={name}
                    isSelected={isSelected}
                    onSelect={selectDriver}
                />
            ))}
        </div>
    );
}

function mapStateToProps(state) {
    const selectedDriver = drivers.getSelectedDriver(state);
    const items = ["All", ...DRIVER_ORDER].map(item => {
        return {
            name: item,
            isSelected:
                item === selectedDriver ||
                (selectedDriver === undefined && item === "All")
        };
    });
    return {
        items
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectDriver: driver => dispatch(drivers.selectDriver(driver))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriverSelect);



// WEBPACK FOOTER //
// ./src/components/Results/DriverSelect.js